import '@/app/app.css';
import './vacancies.css';
import '@/app/app';

import { CollapseBox } from '@/shared/common/collapse-box/collapse-box';
import { initVacanciesTeamSlider } from '@/templates/vacancies/sections/vacancies-team/vacancies-team-slider/vacancies-team-slider';
import { initVacanciesOfferSlider } from '@/templates/vacancies/sections/vacancies-offer/vacancies-offer';
import { initVacanciesFaq } from '@/templates/vacancies/sections/vacancies-faq/vacancies-faq';

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-collapse-box').forEach((element) => new CollapseBox(element));
	initVacanciesTeamSlider();
	initVacanciesOfferSlider();
	initVacanciesFaq();
});
